import { motion } from 'motion/react'
import { format } from 'date-fns'

export default function ChatListItem({ convo, isActive, onClick }: any) {
  const name = convo.title || 'Chat'
  const msg = convo.last_msg || ''
  const time = convo.last_msg_time ? format(new Date(convo.last_msg_time), 'h:mm a') : ''

  return (
    <motion.div whileTap={{ scale: 0.98 }} className={`item ${isActive ? 'active' : ''}`} onClick={onClick}>
      <div className="avatar">{name[0].toUpperCase()}</div>
      <div className="info">
        <div className="top">
          <span className={`name ${convo.unread > 0 ? 'bold' : ''}`}>{name}</span>
          {time && <span className="time">{time}</span>}
        </div>
        <div className="bottom">
          <span className="msg">{msg || 'Tap to start chatting'}</span>
          {convo.unread > 0 && <span className="badge">{convo.unread > 99 ? '99+' : convo.unread}</span>}
        </div>
      </div>
      <style>{`
        .item { display: flex; align-items: center; gap: 14px; padding: 12px 20px; cursor: pointer; transition: background 0.1s; border-bottom: 1px solid var(--border); }
        .item.active { background: var(--accent-dim); }
        .avatar { width: 50px; height: 50px; border-radius: 50%; background: var(--accent-dim); color: var(--accent); display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 18px; flex-shrink: 0; }
        .info { flex: 1; min-width: 0; }
        .top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 3px; }
        .name { font-size: 15px; color: var(--text-primary); font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 65%; }
        .name.bold { font-weight: 700; }
        .time { font-size: 11px; color: var(--text-muted); flex-shrink: 0; }
        .bottom { display: flex; justify-content: space-between; align-items: center; }
        .msg { font-size: 13px; color: var(--text-secondary); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 78%; }
        .badge { background: var(--accent); color: #000; font-size: 10px; font-weight: 700; padding: 3px 7px; border-radius: 12px; min-width: 20px; text-align: center; }
      `}</style>
    </motion.div>
  )
}
